/**
 * 안전한 fbq 호출 래퍼
 * - 브라우저 환경 여부 체크
 * - window.fbq 존재 여부 체크
 * - 파라미터는 불변 Readonly 타입으로 제한
 */
import type { FbqParams } from "types/fbq";

export const FB_PIXEL_ID = "1112580104103330";

function isBrowser(): boolean {
  return typeof window !== "undefined";
}

function hasFbq(): boolean {
  return isBrowser() && typeof window.fbq === "function";
}

export function fbqTrack(eventName: string, params?: FbqParams): void {
  if (!hasFbq()) return;
  window.fbq?.("track", eventName, params);
}

export function fbqTrackCustom(eventName: string, params?: FbqParams): void {
  if (!hasFbq()) return;
  window.fbq?.("trackCustom", eventName, params);
}
